var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.086.778H3.857A3.276 3.276 0 00.581 4.056v12.282a3.277 3.277 0 003.278 3.278H16.14a3.277 3.277 0 003.278-3.278V4.056A3.278 3.278 0 0016.143.778h-1.229a1.229 1.229 0 000 2.457h1.229a.82.82 0 01.819.82v12.283a.82.82 0 01-.82.82H3.858a.82.82 0 01-.82-.82V4.056c0-.455.366-.821.818-.821h1.229a1.229 1.229 0 000-2.457zM9.163 14.03a1.19 1.19 0 001.717-.007l4.063-4.185c1.155-1.158-.577-2.897-1.732-1.739l-1.406 1.416c-.32.322-.58.218-.58-.235V2.006a1.225 1.225 0 10-2.45 0V9.28c0 .451-.26.557-.58.235L6.79 8.1c-1.155-1.158-2.887.581-1.732 1.74l4.106 4.19z","fill":"#C3DBF7"}));
}

Download.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Download;

Download.default = Download;
